module.exports = __webpack_public_path__ + "img/public/SiteIcons/streeingWheel.svg?d86eed05";